<template>
  <div>

    <div class="SvgsGroups">
      <!-- <div><SvgIcon1 /> <span>ضمانت بازگشت کالا</span></div>
      <div><SvgIcon2 /> <span>ضمانت اصالت کالا</span></div>
      <div><SvgIcon3 /> <span>خدمات پس از فروش</span></div>
      <div><SvgIcon4 /> <span>تحویل سریع و آسان</span></div> -->
  
      <figure class="m-0 ">
            <img src="../../../../assets/images/svgGroups/1.png" alt="">
            <figcaption>
             تضمین کیفیت
            </figcaption>
          </figure>
      <figure class="m-0">
        <img src="../../../../assets/images/svgGroups/2.png" alt="">
        <figcaption>
          بسته بندی زیبا
        </figcaption>
      </figure>
      <figure class="m-0">
        <img src="../../../../assets/images/svgGroups/3.png" alt="">
        <figcaption>
          پشتیبانی خرید
        </figcaption>
      </figure>
      <figure class="m-0">
        <img src="../../../../assets/images/svgGroups/4.png" alt="">
        <figcaption>
         ارسال به موقع
        </figcaption>
      </figure>
    </div>
    <div class="main" id="svgGroup">
      <div class=" swiper-container" >
        <div
          class="swiper-wrapper "
         
        >
         
      
            <div
              class="swiper-slide px-1 ">
              <figure class="m-0 ">
                <img src="../../../../assets/images/svgGroups/1.png" class="w-100" alt="">
                <figcaption >
                 تضمین کیفیت
                </figcaption>
              </figure>
            </div>
            <div
              class="swiper-slide px-1 ">
              <figure class="m-0">
                <img src="../../../../assets/images/svgGroups/2.png" class="w-100" alt="">
                <figcaption >
                  بسته بندی زیبا
                </figcaption>
              </figure>
            </div>
            <div
              class="swiper-slide px-1 ">
              <figure class="m-0">
                <img src="../../../../assets/images/svgGroups/3.png" class="w-100" alt="">
                <figcaption >
                  پشتیبانی خرید
                </figcaption>
              </figure>
            </div>
            <div
              class="swiper-slide px-1 ">
              <figure class="m-0">
                <img src="../../../../assets/images/svgGroups/4.png" class="w-100" alt="">
                <figcaption >
                 ارسال به موقع
                </figcaption>
              </figure>
            </div>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";

import SvgIcon1 from "../../../../assets/images/svgGroups/1.png";
import SvgIcon2 from "../../../../assets/images/svgGroups/2.png";
import SvgIcon3 from "../../../../assets/images/svgGroups/3.png";
import SvgIcon4 from "../../../../assets/images/svgGroups/4.png";
export default {
  components: {
    SvgIcon1,
    SvgIcon2,
    SvgIcon3,
    SvgIcon4,

  },
  mounted() {
    // this.setActiveProducts(this.typeSlider);
    this.initProductHomeSlider(true);
  },
  methods: {

    initProductHomeSlider(kill = false) {
      this.initSwiper("svgGroup", kill, () => {
        new Swiper(`#svgGroup .swiper-container`, {
          spaceBetween: 30,
          loop: false,
          speed: 500,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },

          breakpoints: {
            250: {
              slidesPerView: 2.5,
              spaceBetween: 60,
            },
            500: {
              slidesPerView: 3,
              spaceBetween: 80,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1500: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
        });
      });
    },
 
  },
 
  watch: {
    // productList() {
    //   this.initProductHomeSlider();
    // },
  },
};
</script>
<style>

.main .swiper {
  padding-bottom: 4rem  !important;
}
.SvgsGroups path,
.SvgsGroups .mainsvgcolor,
.SvgsGroups .mainsvgcolor,
.SvgsGroups rect {
  fill: #b92c2c;
}
.SvgsGroups > div > span {
  font-size: 13px;
}
.SvgsGroups .swiper-pagination {
  bottom: 35px !important;
}
.SvgsGroups .blckSvgColor {
  fill: #454b53;
}
</style>
<style scoped>
.main {
  width: 80%;
  margin: 2rem auto;
  display: none;
}
.svgBox {
  display: flex;
  align-items: center;
  gap: 10px;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;

  border-radius: 20px !important;
}
.SvgsGroups {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 65%;
  gap: 64px;
  margin: 6rem auto;

  justify-items: center;
}
.SvgsGroups figure,.main figure{
  width: fit-content;
  display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      align-items: center;

  justify-items: center;
}
.SvgsGroups figure img{
  width: 70px;
}
.SvgsGroups figcaption{
  text-wrap: nowrap;
}
.main figcaption{
  text-wrap: nowrap;
}
@media screen and (max-width: 768px) {
  .SvgsGroups {
    display: none;
  }
  .main {
    display: block;
  }
}
@media screen and (max-width: 420px) {
  /*.SvgsGroups {
    gap: 64px;
    margin-top: 3rem;
  }*/
  .svgBox {
    font-size: 14px;
  }
}
@media screen and (max-width: 360px) {
  /*.SvgsGroups {
    gap: 64px;
    margin-top: 3rem;
  }*/
  .svgBox {
    font-size: 12px;
  }
}
.SvgsGroups div {
  transform: scale(1.2);
  text-align: center;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
</style>
